import { AnalyticsTracker } from "./AnalyticsTracker";

export class IdleAnalyticsTracker<T> extends AnalyticsTracker<T> {
	submitPageView(): void {
		// intentionally do nothing
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	submitEvent(_eventData: T): void {
		// intentionally do nothing
	}
}
